import { useForm } from 'react-hook-form';
import type { Language } from '@/shared/types';
import type { GenerateIncomeStatementFormValues } from './types';

type Props = {
  language: Language;
};

const useGenerateIncomeStatementForm = ({ language }: Props) => {
  const defaultValues: GenerateIncomeStatementFormValues = {
    lang: language,
  };

  const form = useForm<GenerateIncomeStatementFormValues>({
    mode: 'onChange',
    defaultValues,
  });

  return {
    form,
  };
};

export { useGenerateIncomeStatementForm };
